namespace TabAurous.Administration {
    export interface ItemDiscountRow {
        Id?: number;
        Code?: string;
        CompanyId?: number;
        Details?: ItemDiscountDetailsRow[];
    }

    export namespace ItemDiscountRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Administration.ItemDiscount';
        export const lookupKey = 'ITEMDISC';

        export function getLookup(): Q.Lookup<ItemDiscountRow> {
            return Q.getLookup<ItemDiscountRow>('ITEMDISC');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Code = "Code",
            CompanyId = "CompanyId",
            Details = "Details"
        }
    }
}
